import React, { useEffect, useState } from "react";

const Text = ({ value:initialValue, onChange, options=[], name }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <>
      <select name={name} value={value} onChange={handleChange}>
        {options.map((option, i) => (
          <option key={`select-${i}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
};

Text.defaultProps = {
  value: "",
  name: "select",
};

export default Text;
